import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background-color: #ffffff;
  border: 1px solid #e1e5eb;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 10px;
`;

const Title = styled.div`
  font-weight: bold;
  padding: 15px 15px 5px 15px;
`;

const Content = styled.div`
  padding: 10px 15px;
`;

export default ({ label, children, className, id }) => {
  return (
    <Wrapper className={className} id={id}>
      {label && <Title>{label}</Title>}
      <Content>{children}</Content>
    </Wrapper>
  );
};
